import CoachSerializer from './base';

export default class GoalPlan extends CoachSerializer {}
